module.exports = __webpack_public_path__ + "static/media/welcome2.216422c0.png";